<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{ $t('currency.form.information') }}</h4>
          <p class="sub-header"></p>
          <div class="row">
            <div class="form-group col-12">
              <label for="" class="form-label">{{ $t('currency.form.symbol.label') }}</label>
              <input 
                type="text" 
                readonly="" 
                class="form-control-plaintext"
                v-model="model.symbol"
              >
            </div>
            <div class="form-group col-md-12">
              <label for="" class="form-label">{{ $t('currency.form.code.label') }}</label>
              <input 
                type="text" 
                readonly="" 
                class="form-control-plaintext"
                v-model="model.code"
              >
            </div>
            <div class="form-group col-md-12">
              <label for="" class="form-label">{{$t('currency.form.name.label')}}</label>
              <input 
                type="text" 
                readonly="" 
                class="form-control-plaintext"
                v-model="model.name"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label for="" class="form-label">{{ $t('currency.form.remarks.label') }}</label>
              <p>{{ model.remarks || '' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    currencyID() {
      let parameters = this.parameters || {}
      return parameters.currencyID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.currencyID

      return this.$store.dispatch('currency/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    currencyID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    },
  },
  mounted() {
    if (this.currencyID) {
      this.fetchData()
    }
  }
}
</script>